// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index-top-falcon[data-v-d6c44258]{margin:16px 25px 0 25px;text-align:center}@media (max-width: 970px){.index-top-falcon[data-v-d6c44258]{display:none}}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
